import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';  
import { Router } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormGroupDirective, NgForm } from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CloseScrollStrategy } from '@angular/cdk/overlay';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-svnitsurat',
  templateUrl: './svnitsurat.component.html',
  styleUrls: ['./svnitsurat.component.css']
})
export class SvnitsuratComponent implements OnInit {

  submitted = false;
  hide = true;
  sources = [
    { value: 'Social Media', viewValue: 'Social Media' },
    { value: 'Campus Ambassador', viewValue: 'Campus Ambassador' },
    { value: 'National Enterpreneurship Challenge participant', viewValue: 'National Enterpreneurship Challenge participant' },
    { value: 'Previous year participant', viewValue: 'Previous year participant' },
    { value: 'Online articles/ Newspaper', viewValue: 'Online articles/ Newspaper' },
    { value: 'Others', viewValue: 'Others' },
  ];
  gender = [
    { value: 'Male', viewValue: 'Male' },
    { value: 'Female', viewValue: 'Female' },
    { value: 'Others', viewValue: 'Others' },
    { value: 'No', viewValue: 'Prefer not to say' },
  ];  
  country = [
    { value: 'ind', viewValue: 'India' },
    { value: 'bah', viewValue: 'Bahrain' },
    { value: 'kuw', viewValue: 'Kuwait' },
    { value: 'oman', viewValue: 'Oman' },
    { value: 'quatar', viewValue: 'Qatar' },
    { value: 'saudi', viewValue: 'Saudi Arabia' },
    { value: 'uae', viewValue: 'The United Arab Emirates' },
    { value: 'other', viewValue: 'Other' },
  ];
  bool = [
    { value: 'Yes', viewValue: 'Yes' },
    { value: 'No', viewValue: 'No' },
  ];
  title = 'newMat';
       
  isLinear = true;
  firstFormGroup: FormGroup;
  constructor(private _formBuilder: FormBuilder,private router: Router, private http: HttpClient) {}

  ngOnInit(): void {
    this.firstFormGroup = this._formBuilder.group({
      name: ['', Validators.required],
      members: ['', Validators.required],
      email:['', Validators.compose([Validators.required, Validators.email])],
      // email: ['', [Validators.required, Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      // email: ['', [Validators.required, Validators.email]],
      contact: ['+91', Validators.compose([Validators.required, Validators.min(10)])],
      // contact: ['', Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]
      idea: [''],
      idea_desc: ['']
      
      // matcher: new MyErrorStateMatcher(),
    });
  }
  get f(){  
    return this.firstFormGroup.controls;  
  }  
  
  submit(){

    if (this.firstFormGroup.value.name.length!=0 
      && this.firstFormGroup.value.email.length!=0 
      && this.firstFormGroup.value.contact.length!=0
      && this.firstFormGroup.value.members.length!=0) {
      this.submitted = true;
    var body: any = new FormData();
      body.append('name', this.firstFormGroup.value.name);
      body.append('email', this.firstFormGroup.value.email);
      body.append('members', this.firstFormGroup.value.members);
      body.append('contact', this.firstFormGroup.value.contact);
      body.append('idea', this.firstFormGroup.value.idea);
      body.append('idea_desc', this.firstFormGroup.value.idea_desc);
      this.http.post<any>("https://api3.ecell.in/eureka22/collegereg/", body).subscribe(
        data => {
          Swal.fire('Thank You For registering. We will get back to you soon.')
          this.router.navigateByUrl('/thankyou');
        },
      (error) => {                              //Error callback
      console.error('error caught in component')
      // this.errorMessage = error;
      // this.loading = false;
      Swal.fire('Some error occured, please contact eurek2022@ecell.in')
      }
        
      )
          
      }
    else{
      Swal.fire('Fill all the required details to register')
    }
  
}
}